import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'
import { Tag } from '../Snippet';
import { useFormatter } from 'src/mtska-frontend-app-component/utils';


const RelationshipAudienceCheck = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t } = useTranslation();
    const { formatDatetime } = useFormatter();

    return (

        <ListItem k={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                <Box className="status coupled">
                    <Box className="label">{t('status')}</Box>
                    {
                        v.status == 'sottomessa' && <Tag color={'warning'} size="small" label={t(v.status)} />
                    }
                    {
                        v.status == 'restituita' && <Tag color={'success'} size="small" label={t(v.status)} />
                    }
                </Box>
                <Box className="date coupled">
                    <Box className="label">{t('date_check')}</Box>
                    <Box className="value">
                        {formatDatetime(v.check_at)}
                    </Box>
                </Box>
                {
                    v?.error &&
                    <Box className="total coupled">
                        <Box className="label">{t('error')}</Box>
                        <Box className="value">
                            {v?.error}
                        </Box>
                    </Box>
                }

            </ListItemContent>
            {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
        </ListItem>
    )
}

export default RelationshipAudienceCheck



